import { useTranslation } from "react-i18next"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"
import { useReportFoliosDetailContext } from "../../hooks/useReportFoliosContext"

const SimpleModalDetail = () => {
    const { t } = useTranslation()
    const { modal, closeModal, loadings } = useReportFoliosDetailContext()
    return (
        <SimpleModal
            open={!!modal.open}
            close={() => {
                if (modal.cancel) { modal.cancel() }
                else {
                    closeModal()
                }
            }}
            title={modal.title}
            removeClose={!modal.cancel}
            description={modal.description}
            cancelText={modal.cancelText ?? t('general.cancel')}
            buttonText={modal?.confirmText ?? t('general.confirm')}
            back={modal.cancel ? () => { if (modal.cancel) modal.cancel() } : undefined}
            loadingButton
            isLoading={!!loadings.next}
            next={() => {
                if (modal.confirm) modal.confirm()
                else { closeModal() }
            }}
        />
    )
}

export { SimpleModalDetail }
